import React, { Component } from 'react';
import styles from './index.module.scss';
import PropTypes from 'prop-types';
import http from '@/assets/api/http';
import { connect } from 'react-redux';
import KeepAlive from '@/routes/KeepAlive';
import { autoPageNum, autopageSize } from '@/assets/config';
import { addOneBreadcrumbPath, keepSecondNavBreadcrumb } from '@/reducers/home/actions';
import { XOKButton, XCancelButton, XInput, XSelect, showConfirm } from '@/components/xqxc_ui';
import { SearchBox, SearchItem } from '@/components/Layout';
import TableBox from './components/TableBox';
import model from '@/reducers/system/versions/model';
import { message } from 'antd';

const states = [
    { code: '1', value: '启用' },
    { code: '0', value: '禁用' }
];

class List extends Component {

    static propTypes = {
        history: PropTypes.object.isRequired,//路由对象
        addOneBreadcrumbPath: PropTypes.func, // 新增3级面包屑导航信息
        keepSecondNavBreadcrumb: PropTypes.func, // 保持2级面包屑导航信息
        getVersionList: PropTypes.func,//获取表格数据
        versionList: PropTypes.object,//表格数据
        getAppTypes: PropTypes.func,
        appTypes: PropTypes.array,
    }

    static defaultProps = {
        versionList: {
            dataList: [], pageNum: 1, pageSize: 30, resultTotal: 0
        },
        appTypes: [],
    }

    state = {
        version: '',
        typeItem: {},
        statusItem: {},
    }

    componentDidMount() {
        const { keepSecondNavBreadcrumb, getAppTypes } = this.props;
        keepSecondNavBreadcrumb();
        getAppTypes({ enumName: 'AppTypeEnum' });
    }

    // 查询触发
    onSearch = (useCache) => {
        const { version, statusItem, typeItem, pageNum, pageSize } = this.state;
        this.searchCache = {
            version, state: statusItem.code, appType: typeItem.code,
            pageNum: useCache == 'useCache' ? pageNum : autoPageNum, // 【第2步，当有useCache时使用当前分页状态，否则使用默认分页状态】
            pageSize: useCache == 'useCache' ? pageSize : autopageSize, // 【第2步，当有useCache时使用当前分页状态，否则使用默认分页状态】
        };
        this.props.getVersionList(this.searchCache);
        KeepAlive.saveCache({ ...this.searchCache, statusItem, typeItem }); // 【第3步，缓存查询状态】
    }

    // 重置触发
    onReset = () => {
        this.setState({ version: '', statusItem: {}, typeItem: {} }, () => {
            KeepAlive.saveResetFunc(this._searchHandle); // 【第4步：将是否调用重置交给KeepAlive控制】
        });
    }

    //分页改变
    onPageChange = (pageSize, pageNum) => {
        this.setState({ pageSize, pageNum }, () => {
            this.onSearch('useCache');
        });
    }

    //路由页面跳转
    onPageJump = (title, url) => {
        const { addOneBreadcrumbPath, history } = this.props;
        const baseUrl = '/home/system/versions';
        addOneBreadcrumbPath({ title, path: baseUrl });
        history.push({
            pathname: `${baseUrl}${url}`
        });
    }

    onCreate = () => {
        this.onPageJump('创建版本', '/create');
    }

    onRequest = (url, data, tip) => {
        http(url, data, 'POST')
            .then(() => {
                this.onSearch('useCache');
                message.success(tip);
            })
            .catch(err => message.error(err.message));
    }

    onTableOperate = (type, values) => {
        switch (type) {
            case 'edit':
                this.onPageJump('编辑版本', `/edit/${values.id}`);
                break;
            case 'open':
                showConfirm('您确定要启用此版本？', '', () => {
                    this.onRequest('/?cmd=com.xqxc.api.pig.mis.biz.platform.AppVersionMisService.updateAppVersionManageState', { id: values.id, state: '1' }, '启用操作成功');
                });
                break;
            case 'ban':
                showConfirm('您确定要禁用此版本？', '', () => {
                    this.onRequest('/?cmd=com.xqxc.api.pig.mis.biz.platform.AppVersionMisService.updateAppVersionManageState', { id: values.id, state: '0' }, '禁用操作成功');
                });
                break;
            case 'remove':
                showConfirm('您确定要删除此版本？', '', () => {
                    this.onRequest('/?cmd=com.xqxc.api.pig.mis.biz.platform.AppVersionMisService.deleteByPrimaryKey', { id: values.id }, '删除操作成功');
                });
                break;
            default:
                break;
        }
    }

    render() {
        const { version, typeItem, statusItem } = this.state;
        const { versionList, appTypes } = this.props;

        return <KeepAlive render={(state) => {
            if (!this.state.__aliveInit) {
                this.setState({ ...state, __aliveInit: true }, () => {
                    this.onSearch('useCache'); // 【第1步：调用查询接口初始化数据】
                });
            }
        }}>
            <div className={styles.flexBoxContainer}>
                <SearchBox>
                    <SearchItem>
                        <XInput
                            label='版本号'
                            placeholder='请输入'
                            bindThis={this}
                            bindName='version'
                            value={version}
                            showLength={false}
                            maxLength={20}
                        />
                    </SearchItem>
                    <SearchItem>
                        <XSelect
                            label='APP类型'
                            placeholder='请选择状态'
                            renderData={appTypes}
                            bindThis={this}
                            bindName='typeItem'
                            dataIndex='value'
                            keyIndex='code'
                            value={typeItem.value}
                        />
                    </SearchItem>
                    <SearchItem>
                        <XSelect
                            label='状态'
                            placeholder='请选择状态'
                            renderData={states}
                            bindThis={this}
                            bindName='statusItem'
                            dataIndex='value'
                            keyIndex='code'
                            value={statusItem.value}
                        />
                    </SearchItem>
                    <SearchItem>
                        <XOKButton
                            label='查询'
                            onClick={this.onSearch}
                        />
                        <XCancelButton
                            label='重置'
                            onClick={this.onReset}
                        />
                    </SearchItem>
                </SearchBox>
                <XOKButton
                    style={{ width: '120px', marginTop: '5px' }}
                    label='新增版本'
                    onClick={this.onCreate}
                />
                <TableBox
                    tableOperate={this.onTableOperate}
                    tableData={versionList}
                    onPageJump={this.onPageJump}
                    onPageChange={this.onPageChange}
                />
            </div>
        </KeepAlive>;
    }
}

export default connect(state => ({
    versionList: state.versions.versionList,
    appTypes: state.versions.appTypes,
}), {
    addOneBreadcrumbPath,
    keepSecondNavBreadcrumb,
    ...model.actions
})(List);